import "./lib/sentry";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import Clarity from "@microsoft/clarity";
import { I18nextProvider } from "react-i18next";
import { i18next } from "@/lib/i18n";
import AppProviders from "@/providers";
import { useAuth } from "@/features/auth";
import { NotFound } from "@/features/not-found";
import { routeTree } from "./routeTree.gen";

const clarityProjectId = import.meta.env.VITE_CLARITY_PROJECT_ID;
const router = createRouter({
  routeTree,
  context: {
    auth: undefined!,
  },
  notFoundMode: "root",
  defaultNotFoundComponent: () => <NotFound />,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
  interface HistoryState {
    hideCancelButton?: true;
    fromPrevious?: true;
    withSuccessNotification?: true;
    formData?: Record<string, any>;
  }
}

const App = () => {
  const auth = useAuth();
  return <RouterProvider router={router} context={{ auth }} />;
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <AppProviders>
        <App />
      </AppProviders>
    </I18nextProvider>
  </React.StrictMode>,
);

window.addEventListener(
  "CookieInformationConsentGiven",
  () => {
    if (window.CookieInformation?.getConsentGivenFor("cookie_cat_statistic")) {
      Clarity.init(clarityProjectId);
      Clarity.consentV2();
    }
  },
  { capture: false, once: true },
);
